import "./SocialMedia.css"
export default function SocialImages(props) {
    return props.ModuleDetails.map((md, index) => {

        return <img
            onClick={() =>
                (window.location.href = md.URL)
            }
            className="socialMediaLogo"
            src={md.ImageURL}
            alt={md.ImageAlt}
        />
    })
}